// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2eyGG","calendarButtons":"ClockData_calendarButtons__2Ed4R"};